'use client';

import VacanciesItem from '@/components/ui/vacancies-item';
import { Vacature } from '@/payload-types';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

interface VacanciesListProps {
    vacancies: Vacature[];
}

export default function VacanciesList({ vacancies }: VacanciesListProps) {
    const { t } = useTranslation();
    return (
        <div className="mb-13 flex flex-col lg:mt-8 lg:px-8">
            {vacancies.map((item, index) => (
                <Link key={index} href={`/vacatures/${item.slug}`}>
                    <VacanciesItem
                        key={index}
                        title={item.titel}
                        level={item.level}
                        type={item.uren}
                    />
                </Link>
            ))}
            <Link key="open" href={`/open-sollicitatie`}>
                <VacanciesItem
                    key="open"
                    title={t('open.title')}
                    level={t('open.level')}
                    type={t('open.type')}
                />
            </Link>
        </div>
    );
}
